import React, { useState, useRef  } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from 'reactstrap';
import { QRCodeSVG } from 'qrcode.react';
import html2canvas from 'html2canvas';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const CekDataPesertaGathering = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [qrCodeData, setQrCodeData] = useState('');
  const [fullName, setFullName] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const qrCodeRef = useRef();
  
  const validationSchema = Yup.object({
    email: Yup.string().email('Email tidak valid').required('Email wajib diisi'),
    nohp: Yup.string()
      .matches(/^(?:\+62|0)[0-9]{9,}$/i, 'No HP tidak valid')
      .required('No HP wajib diisi'),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setLoading(true);
    setIsValid(true);
    setQrCodeData('');
    setFullName('');
    
    let formattedNohp = values.nohp.startsWith('0') ? '+62' + values.nohp.slice(1) : values.nohp;
    
    try {
      const response = await fetch('https://rlagency.id/app/api_gathering_upi/check_peserta_gathering.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: values.email, whatsapp: formattedNohp }),
      });
      const result = await response.json();
      
      if (result.exists) {
        setFullName(result.userData.nama);
        setQrCodeData(result.userData.qrcodeData);
        setIsValid(true);
      } else {
        setIsValid(false);
      }
    } catch (error) {
      setIsValid(false);
    }
    
    setLoading(false);
    setModalOpen(true);
    setSubmitting(false);
    resetForm();
  };

  const downloadQRCode = () => {
    html2canvas(qrCodeRef.current).then((canvas) => {
      const link = document.createElement('a');
      const fullNameForFile = fullName.replace(/\s+/g, '_');
      link.href = canvas.toDataURL('image/jpeg');
      link.download = `QR-Gathering-Upi-2025-${fullNameForFile}.jpeg`;
      link.click();
    });
  };

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="container" style={{ maxWidth: '400px', width: '100%' }}>
        <img 
          src={`./logo-upi-dan-yayasan.png`} 
          alt="Logo Gathering" 
          style={{ 
              width: '150px', 
              marginBottom: '20px', 
              display: 'block', 
              margin: '0 auto' 
          }} 
        />
        <h5 className="text-center mb-4" style={{marginTop:'20px'}}>Isi data untuk download QR</h5>
        <div className="card p-4 shadow-sm rounded">
          <Formik
            initialValues={{ email: '', nohp: '' }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="form-group">
                  <label htmlFor="email">Email:</label>
                  <Field type="email" className="form-control" id="email" name="email" required />
                  <ErrorMessage name="email" component="div" className="text-danger small mt-1" />
                </div>
                <div className="form-group" style={{ marginTop: '20px' }}>
                  <label htmlFor="nohp">No Whatsapp Aktif:</label>
                  <Field type="text" className="form-control" id="nohp" name="nohp" required />
                  <ErrorMessage name="nohp" component="div" className="text-danger small mt-1" />
                </div>
                <button style={{ marginTop: '20px' }} type="submit" className="btn btn-primary w-100" disabled={isSubmitting || loading}>
                  {loading ? <Spinner size="sm" /> : 'Cek Data'}
                </button>
              </Form>
            )}
          </Formik>
        </div>
        <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} centered>
          <ModalHeader toggle={() => setModalOpen(!modalOpen)}>
            {isValid ? 'Anda sudah terdaftar' : 'Data Tidak Valid'}
          </ModalHeader>
          <ModalBody style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff', textAlign:'center' }}>
            {isValid ? (
              <div ref={qrCodeRef} className="id-card" style={{ backgroundColor: '#fff' }}>
                <img src={`./logo-upi-dan-yayasan.png`} alt="Logo Gathering" style={{ width: '120px', marginBottom: '20px' }} />
                <h5>UPI-YPTK, MELANGKAH LEBIH MAJU!</h5>
                <hr style={{ width: '85%', margin: '10px auto', borderColor: '#1b1b1b' }} />
                <h6>{fullName}</h6>
                <QRCodeSVG value={qrCodeData} size={256} />
                <small className="mt-3" style={{ fontSize: '11px', padding: '0px 30px 10px 30px' }}>
                  *Download/Screenshot QR Code agar anda diizinkan memasuki venue/gedung acara.
                </small>
              </div>
            ) : (
              <p style={{ color: 'red' }}>Data anda tidak valid atau belum terdaftar</p>
            )}
          </ModalBody>
          <ModalFooter>
            {isValid && <Button color="success" onClick={downloadQRCode}>Download QR Code</Button>}
          </ModalFooter>
        </Modal>

        <button className="btn btn-secondary w-100 mt-3" onClick={() => navigate('/gathering-dosen-dan-upi-yptk')}>
          Kembali
        </button>
      </div>
    </div>
  );
};

export default CekDataPesertaGathering;